const invoiceStates = [
  {
    class: '',
    id: '',
    name: 'Todos los estados'
  },

  {
    class: 'text-color-danger',
    id: 5,
    name: 'Anulado'
  },

  {
    class: 'text-color-success',
    id: 2,
    name: 'Autorizado'
  },

  {
    class: 'text-color-info',
    id: 1,
    name: 'En Proceso'
  },

  {
    class: 'text-color-info',
    id: 0,
    name: 'Pendiente'
  },

  {
    class: 'text-color-products-primary',
    id: 3,
    name: 'Rechazado'
  },

  {
    class: 'text-color-warning',
    id: 4,
    name: 'Reintentar'
  }
]

export default invoiceStates
